import { render, staticRenderFns } from "./TabInquiry.vue?vue&type=template&id=37fe7f41"
import script from "./TabInquiry.vue?vue&type=script&lang=js"
export * from "./TabInquiry.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports